<div class="main">
    <div>
      <button (click)="goToPage('createclub')" type="button" class="btn btn-primary" data-toggle="button"
      routerLink="/createclub">Create Club</button>
  </div>
  <div>
    <button (click)="goToPage('joinclub')" type="button" class="btn1 btn-primary" data-toggle="button"
      routerLink="/joinclub">Join Club</button>
      </div>
 